import cx from 'classnames'
import {ReactNode} from 'react'
import {Field} from 'react-final-form'
import {CheckboxInput} from '../inputs/CheckboxInput'
import {ErrorMessage} from './ErrorMessage'
import {Label} from './Label'

type Props = {
  label?: ReactNode
  name: string
  className?: string
  id?: string
}

export const CheckboxInputField = ({label, name, className, id}: Props) => {
  return (
    <Field
      name={name}
      type="checkbox"
      render={({input, meta}) => {
        const {active, submitError, modifiedSinceLastSubmit} = meta
        const showError = !active && !modifiedSinceLastSubmit && submitError

        return (
          <div className={cx('flex flex-col', className)}>
            <div className="flex gap-2 total-cursor-pointer w-fit">
              <CheckboxInput id={id} {...input} />
              {label && <Label htmlFor={id}>{label}</Label>}
              {showError && <ErrorMessage>{submitError}</ErrorMessage>}
            </div>
          </div>
        )
      }}
    />
  )
}
